import styled from 'styled-components'

import { bp } from '../globalStyles'
import { Container } from './common'

export default styled(Container).attrs({
  desktopOnly: true
})`
  @media (${bp.desktop}) {
    max-width: none;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: center;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;

    & > .Card {
      width: calc(50% - 2rem);
      max-width: 35rem;
      margin: 1rem;
    }
  }

  @media (min-width: 1200px) {
    max-width: 1200px;
  }
`



// WEBPACK FOOTER //
// ./src/components/CardContainer.js